import { render, staticRenderFns } from "./ProjectRolesTab.vue?vue&type=template&id=ea3f9044"
import script from "./ProjectRolesTab.vue?vue&type=script&lang=js"
export * from "./ProjectRolesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports